import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
Vue.config.productionTip = false

Vue.prototype.exFn = function () {
}
import 'vue2-animate/dist/vue2-animate.min.css' //引入动画
import '@/utils/vant.js' // 引入有赞组件
import ElementUI from 'element-ui' // 引入element组件
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
